// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"194":"199e78f5","408":"af8ac2b8","453":"d7446e4a","672":"e1fdafbc","795":"bd69597d","980":"e0d144d8"}[chunkId] + ".chunk.js";
};